import { render } from "./renderSerial.vue?vue&type=template&id=5ba2bccf&scoped=true"
import script from "./renderSerial.vue?vue&type=script&lang=js"
export * from "./renderSerial.vue?vue&type=script&lang=js"

import "./renderSerial.vue?vue&type=style&index=0&id=5ba2bccf&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba2bccf"]])

export default __exports__